import { z } from 'zod';

export const CurrencySchema = z.object({
  code: z.string().length(3).regex(/^[A-Z]{3}$/),
  name: z.string().min(1),
  symbol: z.string().min(1),
  exponent: z.number().int().min(0).max(4),
});

export type Currency = z.infer<typeof CurrencySchema>;

/**
 * A catalogue currency plus whether THIS tenant uses it. `GET /currencies`
 * returns only active ones (that's what every currency picker shows);
 * `GET /currencies?all=1` returns the whole catalogue for the management page.
 */
export const TenantCurrencySchema = CurrencySchema.extend({
  isActive: z.boolean(),
});
export type TenantCurrency = z.infer<typeof TenantCurrencySchema>;

/** Tenant toggle of a currency: `PATCH /currencies/:code`. */
export const CurrencyActivePatchSchema = z.object({
  isActive: z.boolean(),
});
export type CurrencyActivePatch = z.infer<typeof CurrencyActivePatchSchema>;

/**
 * `GET /currencies`. `decimals` carries the exponent of EVERY catalogue
 * currency, active or not — a document stored in a since-deactivated currency
 * must keep formatting with its own precision, so the display registry can
 * never be narrowed to the active subset.
 */
export interface CurrenciesResponse {
  items: TenantCurrency[];
  decimals: Record<string, number>;
  /** The shop's own currency (the platform row). Older APIs omit it. */
  baseCurrencyCode?: string | null;
}

/** Platform-admin edit of a currency's display/rounding precision (the single control). */
export const PlatformCurrencyPatchSchema = z.object({
  exponent: z.number().int().min(0).max(4),
});
export type PlatformCurrencyPatch = z.infer<typeof PlatformCurrencyPatchSchema>;
